// Get API key from environment with fallback and validation
const getApiKey = () => {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  if (!key) {
    console.error('REACT_APP_GOOGLE_MAPS_API_KEY is not set in environment variables');
    return '';
  }
  
  if (key.length < 30) {
    console.error('Google Maps API key appears to be invalid (too short)');
    return '';
  }
  
  return key;
};

export const GOOGLE_MAPS_API_KEY = getApiKey();
